export default __webpack_public_path__ + "static/media/background.c195994e.jpg";